import React from 'react';
import { Switch, FormControlLabel, Tooltip } from '@mui/material';
import { useAviso } from '../contexts/AvisoContext';

interface AtualizacoesTempoRealToggleProps {
  label?: string;
}

/**
 * Componente para ativar/desativar atualizações em tempo real para avisos
 */
const AtualizacoesTempoRealToggle: React.FC<AtualizacoesTempoRealToggleProps> = ({ 
  label = 'Atualizações em tempo real' 
}) => {
  const { atualizacoesTempoReal, ativarAtualizacoesTempoReal, desativarAtualizacoesTempoReal } = useAviso();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      ativarAtualizacoesTempoReal();
    } else {
      desativarAtualizacoesTempoReal();
    }
  };

  return (
    <Tooltip title="Ativar/desativar notificações em tempo real para avisos">
      <FormControlLabel
        control={
          <Switch
            checked={atualizacoesTempoReal}
            onChange={handleChange}
            color="primary"
          />
        }
        label={label}
      />
    </Tooltip>
  );
};

export default AtualizacoesTempoRealToggle;
